import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddGoogleReservationSettings1736736800957 implements MigrationInterface {
	name = 'AddGoogleReservationSettings1736736800957'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" ADD "googleReservations" json`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "googleReservations"`)
	}
}
